"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GenericError_1 = require("./GenericError");
exports.default = GenericError_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/GenericError/index.js
// module id = 1718
// module chunks = 8